import React from "react"
import { Navigate, createBrowserRouter } from "react-router-dom"
import Customers from "../Components/Customers/Customers"
import DashBoard from "../Components/Dashboard/DashBoard"
import General from "../Components/General/General"
import Audit from "../Components/Audit/Audit"
import Home from "../Components/Home/Home"
import Loan from "../Components/Loan/Loan"
import ForgotPassword from "../Components/Login/Forgotpassword"
import Login from "../Components/Login/login"
import Savings from "../Components/Savings/Savings"
import Unauthorized from "../Errors/Unauthorized"
import CustomLayout from "../Layout/CustomLayout"
import getPermission from "../Utils/Util"
import GeneralLodger from "../Components/GeneralLedger/GeneralLedger"
import jwt_decode from "jwt-decode";
import DailyWorkTable from "../Components/General/DailyWorkTable"
import DailyTransactions from "../Components/General/DailyTransactions"
import UserLoginDetailsTable from "../Components/General/UserLoginDetailsTable"
import UserActivityLogTable from "../Components/General/UserActivityLogTable"
import LoanPaymentHistoryTable from "../Components/Loan/LoanPaymentHistoryTable";
import CustomerInquirySummaryTable from "../Components/General/CustomerInquirySummaryTable";

import { useEffect, useState } from "react";
import { useAuth } from "../Auth/AuthProvider";


const PrivateRoute = ({ path, element }) => {

    const { loading, tokenExpired, permissions } = useAuth();


    if (loading) return null;

    if (tokenExpired) {
        localStorage.clear();
        return <Navigate to="/" replace />;
    }

    const requiredPermissions = permissionMap[path] || [];
    const hasPermission =
        requiredPermissions.length === 0 ||
        permissions.some((p) => requiredPermissions.includes(p));

    return hasPermission ? element : <Navigate to="/unauthorized" replace />;
};
export const permissionMap = {
    // No permission required
    "/master/home": [],
    "/master/reports": [],
    "/master/reports/dashboard": [],
    "/master/reports/general": [
        "districtWiseLoanAndDepositCount",
        "socialBenefitsAccountReport",
        "investmentSummaryReport",
        "districtWiseLoanAndDepositCount",
        "commonDistributionExcel",
        "investmentSummaryReport",
        "investmentReviewReport",
        "investmentTrailBalance",
        "incomeReportSummaryPDF",
        "statementReportSummaryPDF",
        "accountBalanceCheckCertificate",
        "loanBalanceCheckCertificate",
        "dailyWorkDetails",
        "dailyTransaction",
        "commonDistributionExcel",
        "statementReportSummaryExcel",
        "incomeReportSummaryExcel",
        "customerDetailsReport",
        "customerInquiryView"
    ],
    "/master/reports/general/customer-inquiry-summary": [
        "customerInquiryView"
    ],
    "/master/reports/deposits": [
        "accountListView",
        "closedAccountListView",
        "depositSummary",
        "branchDepositReport",
        "summaryDepositsActiveAndDormant",
        "dormantAccountBranch",
        "districtAndIslandDepositSummary",
        "districtWiseOtherDeposits",
        "productWiseDepositReport",
        "OtherAccountDistrictWise",
        "accountTrailBalance",
        "accountTrailBalanceWasamWise",
        "activeAndDormantBackDateReport",
        "cdPd",
        "monthlyProductWiseDormantReport",
        "accountDetails",
        "fieldCollectionReport",
        "accountCertificate",
        "financialProductWiseSummary",
        "shareAndMemberSummaryExcel",
        "depositSummaryExcel",
        "otherDepositsSummaryExcel",
        "fieldCollectionReportExcel",
        "openAccountDataReport"
    ],
    "/master/reports/loans": [
        "productWiseLoanSummary",
        "loanSummaryReportPDF",
        "loanSummaryForDay",
        "districtWiseLoanReport",
        "districtLoanReport",
        "productAndDistrictWiseLoanReport",
        "loanTrailBalance",
        "loanSummaryExcel",
        "amountWiseLoanDisposeSummary",
        "districtWiseLoanDisposeSummary",
        "loanDisbursementAmount",
        "loanPendingInstallment",
        "loanCertificate",
        "loanInquirySummary",
        "districtWiseDisposeSummary"
    ],
    "/master/reports/customers": [],
    "/master/reports/general-ledger": [
        "acoountGeneralLedger",
        "ledgerReportByLedgerCode",
        "generalLedgerTrailBalance",
        "generalLedgerBranchWiseOpeningBalance"
    ],

    "/master/reports/audit": [
        "transactionBalanceAuditReport",
        "customerRegistrationAuditReport",
        "loanDisposeAuditReport",
        "groupDepositAuditReport",
        "loanValueIssuedAuditReport",
        "compulsoryBalanceAnalysis"
    ],
};


const PrivateRoutes = createBrowserRouter([
    {
        path: "/",
        element: <Login />

    },
    {
        path: "/forgotpassword",
        element: <ForgotPassword />
    },
    {
        path: "/unauthorized",
        element: <Unauthorized />
    },
    {
        path: "/master",
        element: <CustomLayout />,
        children: [
            {
                path: "reports",
                children: [
                    {
                        path: "deposits",
                        element: <PrivateRoute path="/master/reports/deposits" element={<Savings />} />
                    },
                    {
                        path: "loans",
                        element: <PrivateRoute path="/master/reports/loans" element={<Loan />} />
                    },
                    {
                        path: "general",
                        element: <PrivateRoute path="/master/reports/general" element={<General />} />
                    },
                    {
                        path: "customers",
                        element: <PrivateRoute path="/master/reports/customers" element={<Customers />} />
                    },
                    {
                        path: "dashboard",
                        element: <PrivateRoute path="/master/reports/dashboard" element={<DashBoard />} />
                    },
                    {
                        path: "general-ledger",
                        element: <PrivateRoute path="/master/reports/general-ledger" element={<GeneralLodger />} />
                    },
                    {
                        path: "general/daily-work",
                        element: <PrivateRoute path="/master/reports/general/daily-work" element={<DailyWorkTable />} />
                    },
                    {
                        path: "general/daily-transactions",
                        element: <PrivateRoute path="/master/reports/general/daily-transactions" element={<DailyTransactions />} />
                    },
                    {
                        path: "general/user-login-details",
                        element: <PrivateRoute path="/master/reports/general/user-login-details" element={<UserLoginDetailsTable />} />
                    },
                    {
                        path: "general/user-activity-log",
                        element: <PrivateRoute path="/master/reports/general/user-activity-log" element={<UserActivityLogTable />} />
                    },
                    {
                        path: "general/customer-inquiry-summary",
                        element: <PrivateRoute path="/master/reports/general/customer-inquiry-summary" element={<CustomerInquirySummaryTable />} />
                    },
                    {
                        path: "audit",
                        element: <PrivateRoute path="/master/reports/audit" element={<Audit />} />
                    },
                    {
                        path: "loans/loan-payment-history",
                        element: <PrivateRoute path="/master/reports/loans/loan-payment-history" element={<LoanPaymentHistoryTable />} />
                    },


                ]
            },
            {
                path: "home",
                element: <PrivateRoute path="/master/home" element={<Home />} />

            },
        ]

    }
]);
export default PrivateRoutes;
